/* ==========================================================================
   DIIP FORMAT COMPARISON — ปุ่มลูกศรเปิด/ปิดคำอธิบายแต่ละข้อ (Mobile เสมอ + Desktop เมื่อติ๊ก Setting)
   JS ตัวนี้ทำงานเหมือนกันทุกขนาดจอ แค่สลับ Class is-open — CSS เป็นตัวตัดสินว่าจะซ่อน/โชว์คำอธิบาย
   หรือไม่ (Desktop ที่ไม่ได้ติ๊กซ่อน คำอธิบายโชว์ตลอดไม่ว่า is-open จะมีหรือไม่ ดูไฟล์ .css)
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.diip-fc-card__steps').forEach(function (stepsList) {
    var steps = stepsList.querySelectorAll('[data-fc-step]');

    steps.forEach(function (step) {
      var toggleBtn = step.querySelector('[data-fc-step-toggle]');
      if (!toggleBtn) return;

      toggleBtn.addEventListener('click', function () {
        var alreadyOpen = step.classList.contains('is-open');

        // เปิดได้ทีละ 1 ข้อต่อการ์ดเท่านั้น — หุบข้ออื่นทั้งหมดในการ์ดนี้ก่อน
        steps.forEach(function (otherStep) {
          if (otherStep === step) return;
          otherStep.classList.remove('is-open');
          var otherToggle = otherStep.querySelector('[data-fc-step-toggle]');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        });

        var willOpen = !alreadyOpen;
        step.classList.toggle('is-open', willOpen);
        toggleBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

        // ความสูงการ์ดเปลี่ยนตอนเปิด/ปิดข้อ — บนมือถือ VS Badge ต้องคำนวณตำแหน่งใหม่ (เดิมคำนวณแค่ตอนโหลด/ปรับขนาดจอ เลยค้างที่เดิม)
        positionVsBadgesForMobile();
      });
    });
  });

  /*
    DIIP UPDATE: จัดตำแหน่ง VS Badge บนมือถือ — Desktop ใช้ % จาก Liquid
    คำนวณได้เลยเพราะคอลัมน์ความกว้างเท่ากันเป๊ะ แต่มือถือเรียงบน-ล่างแบบ
    ความสูงการ์ดไม่เท่ากัน (เนื้อหาสั้น/ยาวต่างกัน) ต้องวัดตำแหน่งจริงจาก
    getBoundingClientRect แล้วคำนวณจุดกึ่งกลางระหว่างการ์ดคู่นั้นๆ แทน
    (left:50% ถูกบังคับด้วย CSS !important ไปแล้ว เหลือแค่ต้องคำนวณ top)
  */
  function positionVsBadgesForMobile() {
    var isMobile = window.matchMedia('(max-width: 900px)').matches;

    document.querySelectorAll('.diip-fc__grid').forEach(function (grid) {
      var badges = grid.querySelectorAll('.diip-fc__vs-badge');
      var cards = grid.querySelectorAll('.diip-fc-card');
      if (!badges.length || !cards.length) return;

      badges.forEach(function (badge, i) {
        if (!isMobile) {
          badge.style.top = ''; // กลับไปใช้ค่า % จาก Inline Style เดิม (Desktop)
          return;
        }

        var cardA = cards[i];
        var cardB = cards[i + 1];
        if (!cardA || !cardB) return;

        var gridRect = grid.getBoundingClientRect();
        var aRect = cardA.getBoundingClientRect();
        var bRect = cardB.getBoundingClientRect();
        var midpoint = ((aRect.bottom - gridRect.top) + (bRect.top - gridRect.top)) / 2;

        badge.style.top = midpoint + 'px';
      });
    });
  }

  positionVsBadgesForMobile();
  window.addEventListener('resize', positionVsBadgesForMobile);
});
